export default {
  errors: {
    missing_operator: 'L\'expression mathématique n\'a pas d\'opérateur.',
    missing_operands: 'L\'expression mathématique nécessite au moins {operandMin} opérande'
  }
}
